import { css } from 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';

var getWrapProperties = function getWrapProperties(props) {
  var isOneLine = props.isOneLine,
      minBreakpoint = props.minBreakpoint;

  if (isOneLine) {
    if (minBreakpoint !== 'tablet' && minBreakpoint !== 'mobile') {
      return css(["@media (max-width:", "px){flex-wrap:wrap;}"], theme('fannypack.layout.tabletBreakpoint'));
    }

    if (minBreakpoint !== 'mobile') {
      return css(["@media (max-width:", "px){flex-wrap:wrap;}"], theme('fannypack.layout.mobileBreakpoint'));
    }

    return null;
  } else {
    return css(["flex-wrap:wrap;"]);
  }
};
var Columns = styled(Box).withConfig({
  displayName: "styled__Columns",
  componentId: "otaduv-0"
})(["display:flex;", ";", ";&{", ";}"], function (props) {
  return !props.isGapless && css(["margin-left:-", "rem;margin-right:-", "rem;margin-top:-", "rem;&:last-child{margin-bottom:-", "rem;}"], theme('fannypack.layout.gapFactor'), theme('fannypack.layout.gapFactor'), theme('fannypack.layout.gapFactor'), theme('fannypack.layout.gapFactor'));
}, getWrapProperties, theme('fannypack.Columns.base'));

export default Columns;
export { Columns, getWrapProperties };
